/**
 * 极速卖车信息
 */
import React from 'react';

import { Row, Col, Input, Button } from 'antd';

import PageLayout from '../../ui/PageLayout';

import http from '../../../axios/http';

import Loading from '../../ui/Loading';

class MemberStatisticsIndex extends React.Component {

    columns = [{
        title: '序号',
        dataIndex: 'index',
        width: '10%',
    }, {
        title: '商户名称',
        dataIndex: 'memberName',
        width: '20%',
    }, {
        title: '用户数',
        dataIndex: 'memberUsers',
        width: '10%',
    }, {
        title: '总录入',
        dataIndex: 'total',
        width: '10%',
    }, {
        title: '审核中',
        dataIndex: 'verifying',
        width: '10%',
    }, {
        title: '展示中',
        dataIndex: 'onSelling',
        width: '10%',
    }, {
        title: '已下架',
        dataIndex: 'putOff',
        width: '10%',
    }, {
        title: '已过户',
        dataIndex: 'sold',
        width: '10%',
    }, {
        title: '交易中',
        dataIndex: 'trading',
        width: '10%',
    }, {
        title: '审核不通过',
        dataIndex: 'verifyFail',
        width: '10%',
    }, {
        title: '草稿',
        dataIndex: 'draft',
        width: '10%',
    }];

    state = {
        visible: false,
        loadData: '',
        queryData: {},
        loadingVisible: false    //导出遮罩
    };

    //导出数据
    download = () => {
        let queryData = this.state.queryData;
        this.setState({ loadingVisible: true });
        queryData.pageNumber = 1;
        queryData.pageSize = 5000;
        http.download({
            url: '/mallStatistic/member/statistic/download',
            data: queryData,
            fileName: "商城商户车辆数据记录.xlsx",
            success: (res) => {
                this.setState({ loadingVisible: false });
            },
            error: (res) => {
                this.setState({ loadingVisible: false });
            }
        });
    }

    inputSearch = (value) => {
        let queryData = this.state.queryData;
        queryData.name = value
        this.state.loadData(queryData);
        this.setState({ queryData: queryData });
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={24}>
                                <Input.Search
                                    placeholder="商户名称"
                                    onSearch={this.inputSearch}
                                    enterButton
                                    style={{ width: '250px' }}
                                />
                                <Button type="primary" onClick={this.download} style={{ "float": "right" }}>导出</Button>
                            </Col>
                        </Row>
                    )}
                    rowKey="index"
                    url="/mallStatistic/member/statistic"
                    requestType="get"
                    columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />
                <Loading visible={this.state.loadingVisible} message="正在导出，请稍候..." />
            </div>
        )
    }
}

export default MemberStatisticsIndex;